import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Container, Row, Col, Card } from 'react-bootstrap';
import { ArrowLeftCircle, CheckCircle, Cart } from 'react-bootstrap-icons';
import axios from 'axios';
import { API } from '../../../api/URL_API';
import { useTiendaConfig } from '../../../hooks/useTiendaConfig';
import getIcon from '../../../utils/getIcon';
import Loader from './componenetes/Loader';
import { useNavigate } from 'react-router-dom';
import icon from '../../../utils/cr1-logo.png';

function ViewPedido() {
    const { numPedido } = useParams();
    const { socialLinks } = useTiendaConfig();
    const [pedido, setPedido] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPedido = async () => {
            try {
                const response = await axios.get(`${API}/api/verpedidos/carrito/${numPedido}`);
                setPedido(response.data);
                console.log('Datos del pedido:', response.data);
            } catch (error) {
                console.error('Error al obtener los datos del pedido:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchPedido();
    }, [numPedido]);

    const redirectToRoot = () => {
        navigate(`/`);
    };

    if (loading) return <div className="text-center"><Loader /></div>;
    if (!pedido || !pedido.productos || pedido.productos.length === 0) return <div>No hay productos en este pedido.</div>;

    const totalItems = pedido.productos.reduce((acc, item) => acc + item.cantidad, 0);
    const totalProductos = pedido.productos.reduce((acc, item) => acc + item.subtotal, 0);

    const formatCop = (value) => value?.toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    }) || '$0';

     const textoEnvio =
        pedido.costoEnvio > 0
            ? formatCop(pedido.costoEnvio)
            : '+ Costo de envío';

    return (
        <>
            <Container fluid className="p-0 min-vh-100" style={{ backgroundColor: '#ffffff' }}>
                {/* Encabezado minimalista */}
                <header style={{ backgroundColor: '#2b235e', color: '#ffffff', padding: '1.5rem 1rem' }}>
                    <Container>
                        <Row className="align-items-center">
                            <Col xs={12} sm={6} className="text-center text-sm-start mb-3 mb-sm-0">
                                <img src={icon} alt="crishacaps" width="100" className="img-fluid" style={{ maxWidth: '120px' }} />
                            </Col>
                            <Col xs={12} sm={6} className="text-center text-sm-end">
                                <Button
                                    className="fw-bold d-inline-flex align-items-center"
                                    onClick={redirectToRoot}
                                    style={{ backgroundColor: '#dc3545', borderColor: '#dc3545', fontSize: '0.9rem' }}
                                >
                                    <ArrowLeftCircle className="me-2" size={18} /> Catálogo
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </header>

                <Container className="py-4 px-3 px-sm-4">

                    {/* Status del pedido */}
                    <div className="mb-4 p-3 rounded" style={{ backgroundColor: '#e8f5e9', borderLeft: '4px solid #dc3545' }}>
                        <div className="d-flex align-items-center">
                            <CheckCircle className="me-2" size={24} style={{ color: '#dc3545' }} />
                            <div>
                                <p className="mb-1 fw-bold" style={{ color: '#2b235e' }}>Pedido Confirmado</p>
                                <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>Número: <strong className="text-danger">{pedido.numPedido}</strong></p>
                            </div>
                        </div>
                    </div>

                    <Row className="g-3">
                        {/* Información General */}
                        <Col lg={6} xs={12}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header style={{ backgroundColor: '#2b235e', color: '#ffffff' }} className="fw-bold d-flex align-items-center py-3">
                                    <CheckCircle className="me-2" size={20} /> Información del Pedido
                                </Card.Header>
                                <Card.Body className="p-3">
                                    <div className="mb-3 pb-3 border-bottom">
                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Fecha</p>
                                        <p className="fw-bold mb-0">{new Date(pedido.creacion).toLocaleDateString('es-CO')}</p>
                                    </div>

                                    {(pedido.nombreCliente || pedido.telefonoCliente) && (
                                        <div className="mb-3 pb-3 border-bottom">
                                            <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Cliente</p>
                                            <p className="fw-bold mb-0">{pedido.nombreCliente || 'No registrado'}</p>
                                            {pedido.telefonoCliente && <p className="mb-0 text-muted" style={{ fontSize: '0.85rem' }}>Tel: {pedido.telefonoCliente}</p>}
                                        </div>
                                    )}

                                    <div className="mb-3 pb-3 border-bottom">
                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Items Totales</p>
                                        <p className="fw-bold mb-0">{totalItems} artículos</p>
                                    </div>

                                    <div className="mb-3 pb-3 border-bottom">
                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Subtotal</p>
                                        <p className="fw-bold mb-0">{formatCop(totalProductos)}</p>
                                    </div>

                                    {pedido.descuento > 0 && (
                                        <div className="mb-3 pb-3 border-bottom">
                                            <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Descuento</p>
                                            <p className="fw-bold mb-0 text-danger">{pedido.descuento}%</p>
                                        </div>
                                    )}

                                    <div className="mb-3 pb-3 border-bottom">
                                        <p className="text-muted mb-1" style={{ fontSize: '0.85rem', textTransform: 'uppercase' }}>Costo de Envío</p>
                                        <p className="fw-bold mb-0">{textoEnvio}</p>
                                    </div>

                                    <div className="pt-2" style={{ backgroundColor: '#f8f9fa', padding: '12px', borderRadius: '6px' }}>
                                        <p className="text-muted mb-1" style={{ fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total del Pedido</p>
                                        <p className="fw-bold mb-0" style={{ fontSize: '1.5rem', color: '#dc3545' }}>{formatCop(pedido.totalPedido)}</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        {/* Resumen de Productos */}
                        <Col lg={6} xs={12}>
                            <Card className="border-0 shadow-sm h-100">
                                <Card.Header style={{ backgroundColor: '#2b235e', color: '#ffffff' }} className="fw-bold d-flex align-items-center py-3">
                                    <Cart className="me-2" size={20} /> Productos
                                </Card.Header>
                                <Card.Body className="p-3">
                                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                        {pedido.productos.map((item, index) => (
                                            <div key={index} className="mb-3 pb-3 border-bottom" style={{ display: 'flex', gap: '12px' }}>
                                                <img
                                                    src={item.imgProducto}
                                                    alt={item.nomProducto}
                                                    width="70"
                                                    height="70"
                                                    className="rounded"
                                                    style={{ objectFit: 'contain', backgroundColor: '#f5f5f5', padding: '4px', flex: '0 0 70px' }}
                                                />
                                                <div style={{ flex: 1, minWidth: 0 }}>
                                                    <p
                                                        className="fw-bold mb-1"
                                                        style={{
                                                            fontSize: '0.95rem',
                                                            color: '#2b235e',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        {item.nombreOriginal || item.nomProducto}
                                                    </p>
                                                    <p className="text-muted mb-1" style={{ fontSize: '0.85rem' }}>
                                                        Cantidad: <strong className="text-dark">{item.cantidad}</strong>
                                                    </p>
                                                    <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>
                                                        Precio U: <strong className="text-dark">{formatCop(item.precioU)}</strong>
                                                    </p>
                                                    <p className="fw-bold mb-0" style={{ fontSize: '0.9rem', color: '#dc3545' }}>
                                                        Subtotal: {formatCop(item.subtotal)}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Enlaces sociales al final */}
                    <div className="mt-5 pt-4 text-center border-top">
                        <p className="text-muted mb-3">Síguenos en nuestras redes</p>
                        <div>
                            {socialLinks.map((link, index) => (
                                <a key={index} href={link.url} target='_blank' rel="noopener noreferrer" title={link.title}>
                                    <Button variant='link' className='fs-5 mx-2' style={{ color: '#2b235e' }}>
                                        {getIcon(link.url)}
                                    </Button>
                                </a>
                            ))}
                        </div>
                    </div>
                </Container>
            </Container>
        </>
    );
}

export default ViewPedido;
